<template>
  <div class="wrapper">
    <div class="shader"></div>
    <div class="table">
      <div class="header">
        <span>请点击表格行选择要添加的商品</span>
        <span @click.stop="closeSelf"><i class="el-icon-close"></i></span>
      </div>
      <div class="goods_type_box">
        <div
          :style='now==item ? "color:#141414;font-weight:bold;" : ""'
          v-for='(item, index) in navList'
          @click="dev(item)"
          :key="index"
        >
          {{item}}
        </div>
      </div>
      <div class="table_box">
        <el-table
          v-if="part_type == 'plank'"
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          height="100%"
          @filter-change="filterHandler"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="60"/>
        <el-table-column
          column-key="color"
          prop="color"
          label="板材颜色"
          :filter-multiple="false"
          :filters="filterOptions.color"
        />
        <el-table-column
          prop="type"
          column-key="type"
          label="基材"
          :filter-multiple="false"
          :filters="filterOptions.type"
        />
        <el-table-column
          prop="thick"
          column-key="thick"
          label="厚度"
          :filter-multiple="false"
          :filters="filterOptions.thick"
        />
        <el-table-column
          prop="spec"
          column-key="spec"
          label="规格"
          :filter-multiple="false"
          :filters="filterOptions.spec"
        />
         <el-table-column
          prop="count"
          column-key="count"
          label="数量"
        >
          <template slot-scope="{row}">
            <editable-cell
              inputType="number"
              :search="false"
              :editPermission="true"
              :text="row.count"
              @change="onCellChange(row, 'count', $event)"
              @select="select(row, 'count', $event)"
              :width="60"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="count"
          column-key="count"
          label="当前库存"
        /> -->
        <el-table-column
          prop="price"
          column-key="price"
          label='会员价'
        />
        <el-table-column
          column-key="class"
          prop="class"
          label="分类"
        />
        <el-table-column
          prop="brand"
          column-key="brand_name"
          label="品牌"
        />
        <el-table-column
          prop="texture_method"
          column-key="texture_method"
          label="贴面工艺"
        />
        <el-table-column
          prop="texture"
          column-key="texture"
          label="钢板纹理"
        />
        <el-table-column
          prop="remark"
          column-key="remark"
          label="备注"
        />
        </el-table>
        <el-table
          v-if="part_type == 'hardware'"
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          height="350px"
          @filter-change="filterHandler"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="60"/>
          <el-table-column
            column-key="color"
            prop="color"
            label="颜色"
            :filter-multiple="false"
            :filters="filterOptions.color"
          />
          <el-table-column
            prop="type"
            column-key="type"
            label="材质"
            :filter-multiple="false"
            :filters="filterOptions.type"
          />
          <el-table-column
            prop="thick"
            column-key="thick"
            label="厚度"
            :filter-multiple="false"
            :filters="filterOptions.thick"
          />
          <el-table-column
            prop="spec"
            column-key="spec"
            label="规格"
            :filter-multiple="false"
            :filters="filterOptions.spec"
          />
          <el-table-column
            prop="count"
            column-key="count"
            label="数量"
          >
            <template slot-scope="{row}">
              <editable-cell
                inputType="number"
                :search="false"
                :editPermission="true"
                :text="row.count"
                @change="onCellChange(row, 'count', $event)"
                @select="select(row, 'count', $event)"
                :width="60"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="count"
            column-key="count"
            label="当前库存"
          /> -->
          <el-table-column
            prop="price"
            column-key="price"
            label='会员价'
          />
          <el-table-column
            column-key="class"
            prop="class"
            label="分类"
            :filter-multiple="false"
            :filters="filterOptions.class"
          />
          <el-table-column
            prop="brand"
            column-key="brand_name"
            label="品牌"
            :filter-multiple="false"
            :filters="filterOptions.brand_name"
          />
          <el-table-column
            prop="remark"
            column-key="remark"
            label="备注"
          />
        </el-table>
        <el-table
          v-if="part_type == 'edge'"
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          height="350px"
          @filter-change="filterHandler"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="60"/>
          <el-table-column
            column-key="color"
            prop="color"
            label="颜色"
            :filter-multiple="false"
            :filters="filterOptions.color"
          />
          <el-table-column
            prop="type"
            column-key="type"
            label="材质"
            :filter-multiple="false"
            :filters="filterOptions.type"
          />
          <el-table-column
            prop="thick"
            column-key="thick"
            label="厚度"
            :filter-multiple="false"
            :filters="filterOptions.thick"
          />
          <el-table-column
            prop="spec"
            column-key="spec"
            label="规格"
            :filter-multiple="false"
            :filters="filterOptions.spec"
          />
          <el-table-column
            prop="count"
            column-key="count"
            label="数量"
          >
            <template slot-scope="{row}">
              <editable-cell
                inputType="number"
                :search="false"
                :editPermission="true"
                :text="row.count"
                @change="onCellChange(row, 'count', $event)"
                @select="select(row, 'count', $event)"
                :width="60"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="count"
            column-key="count"
            label="当前库存"
          /> -->
          <el-table-column
            prop="price"
            column-key="price"
            label='会员价'
          />
          <el-table-column
            prop="remark"
            column-key="remark"
            label="备注"
          />
        </el-table>
        <el-table
          v-if="part_type == 'door'"
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          height="350px"
          @filter-change="filterHandler"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="60"/>
          <el-table-column
            column-key="color"
            prop="color"
            label="颜色"
            :filter-multiple="false"
            :filters="filterOptions.color"
          />
          <el-table-column
            prop="type"
            column-key="type"
            label="材质"
            :filter-multiple="false"
            :filters="filterOptions.type"
          />
          <el-table-column
            prop="thick"
            column-key="thick"
            label="厚度"
            :filter-multiple="false"
            :filters="filterOptions.thick"
          />
          <el-table-column
            prop="spec"
            column-key="spec"
            label="规格"
            :filter-multiple="false"
            :filters="filterOptions.spec"
          />
          <el-table-column
            prop="count"
            column-key="count"
            label="数量"
          >
            <template slot-scope="{row}">
              <editable-cell
                inputType="number"
                :search="false"
                :editPermission="true"
                :text="row.count"
                @change="onCellChange(row, 'count', $event)"
                @select="select(row, 'count', $event)"
                :width="60"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="count"
            column-key="count"
            label="当前库存"
          /> -->
          <el-table-column
            prop="price"
            column-key="price"
            label='会员价'
          />
          <el-table-column
            column-key="class"
            prop="class"
            label="分类"
            :filter-multiple="false"
            :filters="filterOptions.class"
          />
          <el-table-column
            prop="remark"
            column-key="remark"
            label="备注"
          />
        </el-table>
        <el-table
          v-if="part_type == 'other'"
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          height="350px"
          @filter-change="filterHandler"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="60"/>
          <el-table-column
            column-key="color"
            prop="color"
            label="颜色"
            :filter-multiple="false"
            :filters="filterOptions.color"
          />
          <el-table-column
            prop="type"
            column-key="type"
            label="材质"
            :filter-multiple="false"
            :filters="filterOptions.type"
          />
          <el-table-column
            prop="thick"
            column-key="thick"
            label="厚度"
            :filter-multiple="false"
            :filters="filterOptions.thick"
          />
          <el-table-column
            prop="spec"
            column-key="spec"
            label="规格"
            :filter-multiple="false"
            :filters="filterOptions.spec"
          />
          <el-table-column
            prop="count"
            column-key="count"
            label="数量"
          >
            <template slot-scope="{row}">
              <editable-cell
                inputType="number"
                :search="false"
                :editPermission="true"
                :text="row.count"
                @change="onCellChange(row, 'count', $event)"
                @select="select(row, 'count', $event)"
                :width="60"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="count"
            column-key="count"
            label="当前库存"
          /> -->
          <el-table-column
            prop="price"
            column-key="price"
            label='会员价'
          />
          <el-table-column
            column-key="class"
            prop="class"
            label="分类"
            :filter-multiple="false"
            :filters="filterOptions.class"
          />
          <el-table-column
            prop="brand"
            column-key="brand_name"
            label="品牌"
            :filter-multiple="false"
            :filters="filterOptions.brand_name"
          />
          <el-table-column
            prop="remark"
            column-key="remark"
            label="备注"
          />
        </el-table>
      </div>
      <div class="pagination">
        <div class="choseGroupBtn">
          <el-button @click="choseItem" :disabled="multipleSelection.length == 0">确认选择</el-button>
          <span>已选择{{multipleSelection.length}}项</span>
        </div>
        
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          :current-page.sync="page"
          :page-size="limit"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import { getObjectList, getFilterOptions } from '../../util/requests';
import { getKeyValueWithFilter, processingFilterOptions } from '../../util/processingData';
import EditableCell from '../../components/cloud/saleEditableCell';

export default {
  components: {
    EditableCell
  },
  props: [
    'supplierInfo'
  ],
  data() {
    return {
      page: 1,
      totalCount: 0,
      limit: 10,
      filters: {},
      filterOptions: {
        class: [],
        type: [],
        spec: [],
        texture_method: [],
        texture: [],
        brand_name: [],
        thick: [],
        color: [] // 要赋初值，否则不监控这些属性的变化
      },
      tableData: [],
      multipleSelection: [],//选择的
      navList:['板材','五金','封边', '门配','设备'],
      now:'板材',
      part_type: 'plank'
    }
  },
  methods: {
    onCellChange(row, key, value) {
      console.log('row',row,key,value)
      row[key] = value;
      
    },
    select(row, key, value){
      console.log('点勾选中',row)
      this.$refs.multipleTable.toggleRowSelection(row, true);
    },
    handleSelectionChange(val) {
        console.log('选中的商品',val)
        this.multipleSelection = val;
      },
    choseItem() {
      this.$emit('confirm', this.multipleSelection.map((item) => {
        item.part_type = this.part_type;
        return item;
      }))
    },
    closeSelf() {
      this.$emit('close');
    },
    /* choseItem(row, column, event) {
      this.$emit('confirm', row)
    }, */
    pageChange(page) {
      this.updateTable(page);
    },
    filterHandler(filters) {
      let keyTarget = ''; // 这个值标明本次变化的属性，其选项列表不改变，以方便用户反复操作同一个属性的选项
      for (let key in filters) {
        this.filters[key] = filters[key];
        if (filters[key].length > 0) {
          keyTarget = key; // 当前属性选项不为‘全部’时，需要保留当前选项，否则根据后端返回更新
        }
      }
      
      // 获取未选择过滤器的其他属性过滤器列表
      this.getFilterOptions(keyTarget);

      // 置page为1，并获取商品列表更新
      this.page = 1;
      this.updateTable(1);
    },
    updateTable(page) {
      // 通过当前过滤器，获取keyValue，传入getObjectList方法，获取到过滤规则下的商品列表
      const keyValue = getKeyValueWithFilter(this.filters);
      console.log('//////',keyValue)
      keyValue.part_type = this.part_type;
      this.$requests.getObjectList(
        this.supplierInfo.uid,
        this.supplierInfo && this.supplierInfo.id ? this.supplierInfo.id : 0,
        keyValue,
        page,
        1
      ).then((res) => {
        this.totalCount = res.count;
        this.tableData = res.list.map((item) => {
          item.count = 0;
          return item;
        });
        console.log('data',this.tableData)
       /*  let list = this.tableData
        for(let i in list){
          list[i].salesVolumes = list[i].count
        } */
        // console.log('///***',this.tableData)
      })
    },
    getFilterOptions(keyTarget) {
      const keyValue = getKeyValueWithFilter(this.filters);
       console.log('******',keyValue)
      keyValue.part_type = this.part_type;
      this.$requests.getFilterOptions(
        this.supplierInfo.uid,
        this.supplierInfo && this.supplierInfo.id ? this.supplierInfo.id : 0,
        keyValue
      ).then((res) => {
          const newFilters= processingFilterOptions(res, keyTarget);
          for (let key in newFilters) {
            this.filterOptions[key] = newFilters[key];
          }
      })
    },
    dev(now){
        this.now = now
        if(now == '板材'){
            this.part_type = 'plank'
            this.updateTable(1);
            this.getFilterOptions();
        }else if(now == '五金'){
            this.part_type = 'hardware'
            this.updateTable(1);
            this.getFilterOptions();
        }else if(now == '封边'){
            this.part_type = 'edge'
            this.updateTable(1);
            this.getFilterOptions();
        }else if(now == '门配'){
            this.part_type = 'door'
            this.updateTable(1);
            this.getFilterOptions();
        }else if(now == '设备'){
            this.part_type = 'other'
            this.updateTable(1);
            this.getFilterOptions();
        }
        // console.log(this.com_type)
    },
  },
  created() {
    this.updateTable(1);
    this.getFilterOptions();
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  .shader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .table {
    width: 1200px;
    border-radius: 4px;
    background-color: white;
    position: absolute;
    padding: 20px;

    .header {
      font-size: 18px;
      margin-bottom: 20px;
      // border: 1px solid red;
      span:nth-child(2){
        position: relative;
        left: 440px;
        cursor: pointer;
        i{
          font-weight:bold;
          font-size: 18px;
        }
      }

    }
    .goods_type_box{
      // border: 1px solid red;
      width:100%;
      padding:0 5px;
      display: flex;
      align-items:center;
      margin-bottom: 20px;
      margin-top: 20px;
      font-size: 16px;
      position: relative;
      cursor: pointer;
      color:#6c6c6c;
      div:not(:last-child){
        margin-right:40px;
      }
    }
    .table_box{
      border: 1px solid rgba(0, 0, 0, 0);
      height: 350px;
    }

    .pagination {
      margin-top: 15px;
      // text-align: right;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
    }
    .choseGroupBtn span {
      margin-left: 10px;
    }
  }
}
</style>